// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3nmqy","title":"FrontImage_title__28Oi5"};